/* eslint-disable react/prop-types */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-unused-expressions */
/* eslint-disable spaced-comment */
/* eslint-disable no-tabs */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-use-before-define */
/* eslint-disable indent */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import "./CorrespondingCrossComponent.scss";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineMinusCircle, AiOutlinePlusCircle } from "react-icons/ai";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { RiCheckboxIndeterminateFill, RiDeleteBinLine } from "react-icons/ri";
import { FaSort, FaSortUp, FaSortDown } from "react-icons/fa";
import { BsInfoCircle } from "react-icons/bs";
import ReactTooltip from "react-tooltip";
import ScrollContainer from "react-indiana-drag-scroll";
import { bundleToCcc } from "../../../../Common/utils/api/bundleFormats";
import Spinner from "../../../../Common/components/Icons/Spinner/Spinner";
import { colKeyToName } from "../../../../Retrofit/utils/CorrespondingCrossComponent/cccUtils";
import t from "../../../../Common/utils/translation/translator";
import prettyPrint from "../../../../Retrofit/utils/CorrespondingCrossComponent/prettyPrint";
import {
  addBundleToCompare,
  clearBundlesToCompare,
  selectBundlesToCompare,
  selectFiltersWrapperOpened,
  setFiltersWrapperOpened,
  unsetBundle,
  showMobileBundleInfoPopup
} from "../../../../Retrofit/store/slices/retrofit";
import Button from "../../../../Common/components/Buttons/Button/Button";
import MsxIcons from "../../../../Common/components/Icons/MsxIcons/MsxIcons";
import useCheckMobileScreen from "../../../../Common/utils/useCheckMobileScreen";
import PersonnalisationPopup from "../../Comparator/PersonnalisationPopup";
import getUtilizationPercentage from "../../../../Retrofit/utils/utilizationPercentage";
import getInertiaRatio from "../../../../Retrofit/utils/inertiaRatio";
import TableSkeleton from "../../../../Common/components/TableSkeleton/TableSkeleton";
import { selectConfigurationType, updateConfiguration } from "../../../../Common/store/slices/common";
import Pagination from "../../../../Common/components/Pagination/Pagination";
import { mobileDefaultColumns } from "../../../../Retrofit/store/data/retrofitData";

const CorrespondingCrossComponent = ({
  selectedBundle,
  onSelectBundle,
  filters,
  defaultColumns,
  choosableColumns,
  bundles,
  isFetchingBundles,
  paging,
  setPaging,
  orderBy,
  setOrderBy,
  countOfBundles,
  disableComparator,
  rowsToShow
}) => {
  const configurationType = useSelector(selectConfigurationType);
  const storageCols = JSON.parse(localStorage.getItem("motion-configurator-" + configurationType + "-table-columns"));

  const isMobile = useCheckMobileScreen();

  const [columns, setColumns] = useState(storageCols || defaultColumns);

  const [sortSelected, setSortSelected] = useState("desc");
  const [columnSelected, setColumnSelected] = useState("nominalTorque");

  const key = Date.now();

  /**
   * Updates the columns and groups displayed in the cross component table
   */
  const updateCustomGroupsAndColumns = (arrayOfGroups) => {
    const newColumns = arrayOfGroups.map((arrayOfColumns, index) => ({
      groupName: defaultColumns[index]?.groupName || "Naming error",
      columns: arrayOfColumns,
      deploy: defaultColumns[index]?.deploy || false
    }));

    setColumns(newColumns);
  };

  useEffect(() => {
    localStorage.setItem("motion-configurator-" + configurationType + "-table-columns", JSON.stringify(columns));
  }, [columns]);

  /**
   * Returns the right deploy button:
   * + if closed
   * - if opened
   */
  function displayDeployButton(group, index) {
    function changeButton(deploy) {
      if (deploy === true) {
        return <AiOutlineMinusCircle className="text-sm" />;
      }
      return <AiOutlinePlusCircle className="text-sm" />;
    }

    if (index === 0) {
      return (
        <button
          type="button"
          onClick={(ev) => {
            ev.stopPropagation();
            const newCustomColumns = [...columns];
            const newGroup = group;
            newGroup.deploy = !group.deploy;

            const indexOfGroup = newCustomColumns.indexOf(group);
            newCustomColumns[indexOfGroup] = newGroup;

            setColumns(newCustomColumns);
          }}
          className="cross-component-button"
          margin={3}
        >
          {changeButton(group.deploy)}
        </button>
      );
    }
    return null;
  }

  function getColumnsHeaderFromGroup(group) {
    return group.columns.map((column, index) => {
      switch (index) {
        case 0:
          return (
            // eslint-disable-next-line no-use-before-define
            (withGearbox || (group.groupName !== "gearbox" && group.groupName !== "accessories")) && (
              <th className="font-normal text-left pl-3 py-3 pr-0" key={`${group.groupName}-${column}-header`}>
                <div className="flex items-center">
                  <span className="text-sm">{t(`msizer.ui.${group.groupName}`)}</span>
                  <span className="mx-2 flex items-center">{displayDeployButton(group, index)}</span>
                  {!group.deploy && <BiDotsHorizontalRounded className="text-xs text-gray-600" />}
                  <hr className="bg-gray-500 h-0.1 flex-1" />
                  {!group.deploy && <span className="bg-gray-500 w-0.1 h-3" />}
                </div>
              </th>
            )
          );
        default:
          return (
            group.deploy &&
            (withGearbox || !["gearboxReference", "adaptationKitRef"].includes(column)) && (
              <th className="px-0" key={`${group.groupName}-${column}-header`}>
                <div className="flex items-center">
                  <span className="text-sm invisible-element w-0">a</span>
                  <hr className="bg-gray-500 h-0.1 flex-1" />
                  {index === group.columns.length - 1 && <span className="bg-gray-500 w-0.1 h-3" />}
                </div>
              </th>
            )
          );
      }
    });
  }

  const sortableColumns = ["nominalTorque", "nominalSpeed"];
  const columnsWithTooltip = ["nominalTorque", "nominalSpeed", "bundleInertia", "inertiaRatio", "length"];
  const columnsTooltips = {
    nominalTorque: (
      <span>
        {t("msizer.ui.select.nominal_torque_tooltip_line1")}
        <br />
        <b>{t("msizer.ui.select.nominal_torque_tooltip_line2")}</b>
        <br />
        {t("msizer.ui.select.nominal_torque_tooltip_line3")}
      </span>
    ),
    nominalSpeed: (
      <span>
        {t("msizer.ui.select.nominal_speed_tooltip_line1")}
        <br />
        <b>{t("msizer.ui.select.nominal_speed_tooltip_line2")}</b>
        <br />
        {t("msizer.ui.select.nominal_speed_tooltip_line3")}
      </span>
    ),
    bundleInertia: (
      <span>
        {t("msizer.ui.select.inertia_ratio_tooltip_line1")}
        <br />
        <b>{t("msizer.ui.select.inertia_ratio_tooltip_line2")}</b>
        <br />
        {t("msizer.ui.select.inertia_ratio_tooltip_line3")}
        <br />
        {t("msizer.ui.select.inertia_ratio_tooltip_line4")}
      </span>
    ),
    inertiaRatio: (
      <span>
        {t("msizer.ui.select.inertia_ratio_tooltip").split("{{n}}")[0]}
        <br />
        {t("msizer.ui.select.inertia_ratio_tooltip").split("{{n}}")[1]}
      </span>
    ),
    length: (
      <span>
        {t("msizer.ui.select.length_tooltip_line1")}
        <br />
        <b>{t("msizer.ui.select.length_tooltip_line2")}</b>
        <br />
        {t("msizer.ui.select.length_tooltip_line3")}
      </span>
    )
  };

  const sortColumn = (column) => {
    setOrderBy({
      ...orderBy,
      attributeName: column,
      sort: sortSelected
    });
    sortSelected === "asc" ? setSortSelected("desc") : setSortSelected("asc");
  };
  /**
   * Display columns titles in the given group.
   * If the group is not deployed, displays only the first column with the + button
   */
  function getColumnsFromGroup(group) {
    return (
      // eslint-disable-next-line no-use-before-define
      (withGearbox || (group.groupName !== "gearbox" && group.groupName !== "accessories")) &&
      group.columns.map((column, index) => {
        if (index === 0) {
          return (
            <th
              className={`font-semibold py-3 border-[1px] border-solid border-gray-200 text-xs text-left px-3 bg-gray-50 ${
                columnSelected === column ? "bg-gray-200" : ""
              }`}
              key={`${group.groupName}-${column}-header`}
              onClick={() => {
                if ((column === "nominalTorque" || column === "nominalSpeed") && !isFetchingBundles) {
                  setColumnSelected(column);
                  sortColumn(column);
                }
              }}
            >
              <span className="flex items-center space-x-2">
                <span className={`${isMobile && "whitespace-normal"}`}>{t(colKeyToName(column))}</span>

                {columnsWithTooltip.includes(column) && (
                  <>
                    <BsInfoCircle data-tip data-for={`${column}-infoTooltip`} className="cursor-pointer" />
                    <ReactTooltip
                      id={`${column}-infoTooltip`}
                      place="top"
                      effect="solid"
                      backgroundColor="#FFFFFF"
                      textColor="rgb(31 41 55)"
                      className="shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
                      multiline
                    >
                      <div>{columnsTooltips[column]}</div>
                    </ReactTooltip>
                  </>
                )}
                {sortableColumns.includes(column) &&
                  !isMobile &&
                  sortSelected === "desc" &&
                  columnSelected === column && <FaSortUp className="cursor-pointer text-gray-600 mt-1 text-base" />}
                {sortableColumns.includes(column) &&
                  !isMobile &&
                  sortSelected === "asc" &&
                  columnSelected === column && <FaSortDown className="cursor-pointer text-gray-600 mb-1 text-base" />}
                {sortableColumns.includes(column) && !isMobile && columnSelected !== column && (
                  <FaSort className="cursor-pointer text-gray-600 text-base" />
                )}
              </span>
            </th>
          );
        }
        return (
          group.deploy &&
          (withGearbox || !["gearboxReference", "adaptationKitRef"].includes(column)) && (
            <th
              className={`font-semibold border-[1px] border-solid border-gray-200 text-xs text-left px-3 bg-gray-50 ${
                columnSelected === column ? "bg-gray-200" : ""
              }`}
              key={`${group.groupName}-${column}`}
              onClick={() => {
                if ((column === "nominalTorque" || column === "nominalSpeed") && !isFetchingBundles) {
                  setColumnSelected(column);
                  sortColumn(column);
                }
              }}
              //onClick={() => sortTemporary(column)}
            >
              <span className="flex items-center space-x-2">
                <span className={`${isMobile && "whitespace-normal"}`}>{t(colKeyToName(column))}</span>

                {columnsWithTooltip.includes(column) && !isMobile && (
                  <>
                    <BsInfoCircle data-tip data-for={`${column}-infoTooltip`} className="cursor-pointer" />
                    <ReactTooltip
                      id={`${column}-infoTooltip`}
                      place="top"
                      effect="solid"
                      backgroundColor="#FFFFFF"
                      textColor="rgb(31 41 55)"
                      className="shadow-[0px_0px_8px_rgba(98,100,105,0.5)] rounded-[10px]"
                      multiline
                    >
                      <div>{columnsTooltips[column]}</div>
                    </ReactTooltip>
                  </>
                )}
                {sortableColumns.includes(column) &&
                  !isMobile &&
                  sortSelected === "desc" &&
                  columnSelected === column && <FaSortUp className="cursor-pointer text-gray-600 mt-1 text-base " />}
                {sortableColumns.includes(column) &&
                  !isMobile &&
                  sortSelected === "asc" &&
                  columnSelected === column && <FaSortDown className="cursor-pointer text-gray-600 mb-1 text-base" />}
                {sortableColumns.includes(column) && !isMobile && columnSelected !== column && (
                  <FaSort className="cursor-pointer text-gray-600 text-base" />
                )}
              </span>
            </th>
          )
        );
      })
    );
  }

  /**
   * Displays a solution with regard to the selected columns.
   * For each group, either take all of the columns if it is deployed or
   * only the first if it is not
   */
  function getTableContents(solution, cols) {
    return cols.map((columnGroup) => {
      if (columnGroup.deploy === true) {
        return (
          (withGearbox || (columnGroup.groupName !== "gearbox" && columnGroup.groupName !== "accessories")) &&
          columnGroup.columns.map(
            (col) =>
              (withGearbox || !["gearboxReference", "adaptationKitRef"].includes(col)) && (
                <td
                  key={`${columnGroup.name}-${col}-${solution.key}`}
                  className="py-2 px-1 md:cross-component-table-cell max-w-[150px] border-b border-x border-dashed border-gray-200"
                >
                  <div className="py-2 px-1 md:cross-component-table-cell text-xs text-ellipsis overflow-hidden">
                    {col === "nominalTorque" || col === "nominalSpeed" ? (
                      getUtilizationPercentage(
                        col,
                        solution[col],
                        filters,
                        col === "nominalTorque" ? t("msizer.ui.unit.nm") : t("msizer.ui.unit.rpm"),
                        isMobile
                      )
                    ) : col === "inertiaRatio" ? (
                      getInertiaRatio(filters?.applicationDataFilter?.loadInertia, solution[col])
                    ) : col === "bundleInertia" ? (
                      solution.inertiaRatio
                    ) : (
                      <span title={prettyPrint(col, solution[col])}>{prettyPrint(col, solution[col])}</span>
                    )}
                  </div>
                </td>
              )
          )
        );
      }
      return (
        (withGearbox || (columnGroup.groupName !== "gearbox" && columnGroup.groupName !== "accessories")) && (
          <td
            key={`${columnGroup.name}-${columnGroup.columns[0]}-${solution.key}`}
            className="py-2 px-1 md:cross-component-table-cell border-b border-r border-dashed border-gray-200"
          >
            <div
              onClick={(e) => {
                if (isMobile) {
                  e.stopPropagation();
                  dispatch(
                    showMobileBundleInfoPopup({
                      solution,
                      detailRef: solution[columnGroup.columns[0]]
                    })
                  );
                }
              }}
              className={`py-2 px-1 md:cross-component-table-cell text-xs ${
                isMobile ? "text-secondary underline" : ""
              }`}
            >
              {prettyPrint(columnGroup.columns[0], solution[columnGroup.columns[0]])}
            </div>
          </td>
        )
      );
    });
  }

  /* NEW VERSION */

  const dispatch = useDispatch();

  const [withGearbox, setWithGearbox] = useState(filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled);

  useEffect(() => {
    setWithGearbox(filters?.motorFilter?.withGearbox || filters?.gearboxFilter?.enabled);
  }, [filters]);

  const [mandatoryFiltersFilled, setMandatoryFiltersFilled] = useState(false);
  const [mandatoryNotFilledFilters, setMandatoryNotFilledFilters] = useState({
    drive: [],
    motor: [],
    gearbox: []
  });

  const filtersWrapperOpened = useSelector(selectFiltersWrapperOpened);
  // when the filters change and filters wrapper is closed and !editingAxis => fetch bundles from api
  useEffect(() => {
    // empty the mandatoryNotFilledFilters and then check if all mandatory filters are filled
    setMandatoryNotFilledFilters({
      drive: [],
      motor: [],
      gearbox: []
    });

    // check drive filters function
    const checkDriveFilters = () => {
      return (
        filters?.driveFilter?.driveInterface?.length > 0 &&
        filters?.driveFilter?.driveInterface?.[0] !== "" &&
        filters?.driveFilter?.nbPhases?.length > 0 &&
        filters?.driveFilter?.nbPhases?.[0] !== "" &&
        filters?.driveFilter?.driveVoltages?.length > 0 &&
        filters?.driveFilter?.driveVoltages?.[0] !== ""
      );
    };

    // check motor filters function
    const checkMotorFilters = () => {
      return (
        filters?.motorFilter?.ipDegreeOfProtection?.length > 0 &&
        filters?.motorFilter?.holdingBrake?.length > 0 &&
        (!withGearbox || filters?.gearboxFilter?.productOrComponentType?.length > 0)
      );
    };

    // check gearbox filters function
    const checkGearboxFilters = () => {
      return !withGearbox || filters?.gearboxFilter?.productOrComponentType?.length > 0;
    };

    // if filters?.driveFilter object is not empty then check if all mandatory filters are filled
    const driveFiltersApplicable = filters?.driveFilter !== undefined && filters?.driveFilter !== null;

    // if filters?.motorFilter object is not empty then check if all mandatory filters are filled
    const motorFiltersApplicable = filters?.motorFilter !== undefined && filters?.motorFilter !== null;

    // if filters?.gearboxFilter object is not empty then check if all mandatory filters are filled
    const gearboxFiltersApplicable = filters?.gearboxFilter !== undefined && filters?.gearboxFilter !== null;

    if (
      (!driveFiltersApplicable || checkDriveFilters()) &&
      (!motorFiltersApplicable || checkMotorFilters()) &&
      (!gearboxFiltersApplicable || checkGearboxFilters())
    ) {
      setMandatoryFiltersFilled(true);
    } else {
      if (
        driveFiltersApplicable &&
        !(filters?.driveFilter?.driveInterface?.length > 0 && filters?.driveFilter?.driveInterface?.[0] !== "")
      ) {
        setMandatoryNotFilledFilters((prev) => ({
          ...prev,
          drive: [...prev.drive, t("msizer.ui.drive_filters.communication_interfaces")]
        }));
      }
      if (
        (driveFiltersApplicable && !(filters?.driveFilter?.nbPhases?.length > 0)) ||
        filters?.driveFilter?.nbPhases?.[0] === ""
      ) {
        setMandatoryNotFilledFilters((prev) => ({
          ...prev,
          drive: [...prev.drive, t("msizer.ui.drive_filters.nb_phases")]
        }));
      }
      if (
        (driveFiltersApplicable && !(filters?.driveFilter?.driveVoltages?.length > 0)) ||
        filters?.driveFilter?.driveVoltages?.[0] === ""
      ) {
        setMandatoryNotFilledFilters((prev) => ({
          ...prev,
          drive: [...prev.drive, t("msizer.ui.drive_filters.supply_voltage")]
        }));
      }
      if (motorFiltersApplicable && !(filters?.motorFilter?.ipDegreeOfProtection?.length > 0)) {
        setMandatoryNotFilledFilters((prev) => ({
          ...prev,
          motor: [...prev.motor, t("msizer.ui.motor_filters.ip_degree_of_protection")]
        }));
      }
      if (motorFiltersApplicable && !(filters?.motorFilter?.holdingBrake?.length > 0)) {
        setMandatoryNotFilledFilters((prev) => ({
          ...prev,
          motor: [...prev.motor, t("msizer.ui.motor_filters.holding_brake")]
        }));
      }
      if (gearboxFiltersApplicable && withGearbox && !(filters?.gearboxFilter?.productOrComponentType?.length > 0)) {
        setMandatoryNotFilledFilters((prev) => ({
          ...prev,
          gearbox: [...prev.gearbox, t("msizer.ui.gearbox_filters.product_type")]
        }));
      }

      setMandatoryFiltersFilled(false);
    }
  }, [filters, paging, orderBy, filtersWrapperOpened]);

  useEffect(() => {
    setPaging({ ...paging, skip: 0 });
  }, [filters]);

  useEffect(() => {
    // change limit when rowsToShow changes
    setPaging({ ...paging, limit: rowsToShow, skip: 0 });
  }, [rowsToShow]);

  const bundlesToCompare = useSelector(selectBundlesToCompare);

  const handleSelectBundle = (bundle) => {
    // call the function onSelectBundle from the parent component
    onSelectBundle(bundle);
  };

  let nbSolution = 0;

  return (
    <div
      key={key}
      className={`CorrespondingCrossComponent border-[1px] border-solid border-gray-100 py-5 md:p-5 relative mt-3 bg-white ${
        isMobile && bundlesToCompare?.length > 0 ? "mb-12" : ""
      }`}
    >
      <div
        onClick={() => dispatch(setFiltersWrapperOpened(null))}
        className={`absolute h-full w-full top-0 left-0 bg-gray-600 opacity-50 z-10 ${
          filtersWrapperOpened ? "" : "hidden"
        }`}
      />
      <div className="bg-white overflow-x-auto space-y-3">
        <div className="cross-component-header flex space-between">
          <div className="flex flex-1 gap-2">
            <span className="text-gray-600 font-bold">
              {`${t("msizer.ui.corresponding_configuration_results")} ${
                !mandatoryFiltersFilled ? "" : isFetchingBundles ? "" : `(${countOfBundles?.toLocaleString()})`
              }`}
            </span>
            <div className="mr-auto">{isFetchingBundles && <Spinner small gray />}</div>
          </div>
          {!isMobile && (
            <div className="cross-component-buttons">
              <PersonnalisationPopup
                choosableColumns={choosableColumns}
                columns={columns}
                colKeyToName={colKeyToName}
                updateCustomGroupsAndColumns={updateCustomGroupsAndColumns}
                isFetchingBundles={isFetchingBundles}
              />
            </div>
          )}
        </div>

        <div className="cross-component-table-div cursor-pointer">
          {/* <DoubleScrollbar> */}
          {mandatoryFiltersFilled ? (
            <ScrollContainer className="scroll-container whitespace-nowrap" hideScrollbars={false}>
              <table cellSpacing={0} className="cross-component-table border-separate">
                <thead className="">
                  {!isMobile && (
                    <tr>
                      {!disableComparator && <th className="main py-3 px-1 text-transparent">.</th>}
                      {columns.map((columnGroup) => {
                        if (columnGroup.groupName === "Gearbox" && !withGearbox) {
                          return null;
                        }
                        return getColumnsHeaderFromGroup(columnGroup);
                      })}
                    </tr>
                  )}
                  <tr>
                    {!disableComparator && (
                      <th className="main py-3 px-1 border-[1px] border-solid border-gray-200 text-secondary cursor-pointer bg-gray-50 sticky left-0">
                        <RiCheckboxIndeterminateFill
                          title="Clear selection"
                          className={`text-xl m-auto ${bundlesToCompare?.length === 0 && "opacity-0"}`}
                          onClick={() => dispatch(clearBundlesToCompare())}
                        />
                      </th>
                    )}
                    {isMobile &&
                      mobileDefaultColumns.map((columnGroup) => {
                        if (columnGroup.groupName === "Gearbox" && !withGearbox) {
                          return null;
                        }
                        return getColumnsFromGroup(columnGroup);
                      })}
                    {!isMobile &&
                      columns.map((columnGroup) => {
                        if (columnGroup.groupName === "Gearbox" && !withGearbox) {
                          return null;
                        }
                        return getColumnsFromGroup(columnGroup);
                      })}
                    {!isMobile && (
                      <th className="main font-semibold border-[1px] border-solid border-gray-200 text-xs text-left px-3 sticky right-0 bg-gray-50">
                        {" "}
                      </th>
                    )}
                  </tr>
                </thead>

                <tbody
                  className="border-b border-solid border-gray-200"
                  // key={`${formattedSol.id}-${solution.selected}`}
                  key="tbody"
                >
                  {!isFetchingBundles &&
                    bundles.map((solution) => {
                      nbSolution += 1;
                      const formattedSol = bundleToCcc(solution);
                      //console.log("formattedSol: ", formattedSol);
                      return (
                        <tr
                          onClick={(e) => {
                            if (disableComparator) return;
                            dispatch(addBundleToCompare(solution));
                          }}
                          className={`group hover:outline-2 hover:outline-dashed hover:outline-gray-300
                          ${
                            selectedBundle?.id === solution.id
                              ? "bg-gray-50 font-semibold outline-2 outline-dashed outline-gray-300"
                              : "hover:bg-gray-10"
                          }
                          `}
                          id={selectedBundle?.id === solution.id ? "selected-bundle" : ""}
                        >
                          {!disableComparator && (
                            <td
                              onClick={(e) => {
                                // e.stopPropagation();
                                if (disableComparator) return;

                                dispatch(addBundleToCompare(solution));
                                dispatch(addBundleToCompare(solution));
                              }}
                              className={`group md:px-2 cross-component-table-checkbox-cell text-center sticky left-0 md:border-x border-solid 
                            ${
                              selectedBundle?.id === solution.id
                                ? "bg-gray-50 border-transparent text-gray-700"
                                : "bg-white border-gray-200"
                            }
                            `}
                            >
                              <div className="flex items-center group-hover:bg-gray-100 w-min md:px-2 py-1 rounded-full m-auto">
                                <input
                                  id={`select-bundle-checkbox-${nbSolution}`}
                                  disabled={
                                    bundlesToCompare?.length === 3 &&
                                    !bundlesToCompare?.find((b) => b.id === solution.id)
                                  }
                                  type="checkbox"
                                  className="group checked:bg-secondary cursor-pointer focus:ring-transparent focus:outline-none disabled:border-gray-200 rounded-sm disabled:cursor-not-allowed"
                                  style={{ margin: 0 }}
                                  checked={bundlesToCompare?.find((b) => b.id === solution.id) || ""}
                                  readOnly
                                />
                                {!isMobile && (
                                  <span
                                    className={`text-xxs px-1 rounded-r group-hover:visible 
                            ${
                              bundlesToCompare?.find((b) => b.id === solution.id)
                                ? selectedBundle?.id === solution.id
                                  ? "visible"
                                  : ""
                                : "invisible-element"
                            }
                            `}
                                  >
                                    {t("msizer.ui.select.table.compare")}
                                  </span>
                                )}
                              </div>
                            </td>
                          )}
                          {isMobile
                            ? getTableContents(formattedSol, mobileDefaultColumns)
                            : getTableContents(formattedSol, columns)}

                          {!isMobile && (
                            <td
                              className={` sticky right-0 border-x border-solid border-gray-200
                            ${
                              selectedBundle?.id === solution.id
                                ? "bg-primary border-transparent px-2"
                                : "bg-white hover:underline decoration-secondary"
                            }
                          `}
                              id={`select-bundle-${nbSolution}`}
                              onClick={(e) => {
                                e.stopPropagation();
                                if (selectedBundle?.id === solution.id) {
                                  // dispatch(unsetBundle());
                                } else {
                                  handleSelectBundle(solution);
                                }
                              }}
                            >
                              <Button
                                classes={`px-5 py-1 m-auto min-w-[6rem] group/btn ${
                                  selectedBundle?.id === solution.id
                                    ? // already selected
                                      "bg-primary w-24 text-white border-primary hover:border-secondary hover:bg-white hover:text-secondary hover:border-[1px] hover:border-secondary"
                                    : "text-secondary border-secondary hover:bg-darksecondary w-full"
                                }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  if (selectedBundle?.id === solution.id) {
                                    dispatch(unsetBundle());
                                    dispatch(updateConfiguration());
                                  } else {
                                    handleSelectBundle(solution);
                                  }
                                }}
                              >
                                <div className="m-auto">
                                  <span className="m-auto group-hover/btn:hidden">
                                    {selectedBundle?.id === solution.id ? (
                                      <div className="flex items-center space-x-1">
                                        <MsxIcons name="notification_ok_wired" size="nano" />
                                        <span>{t("msizer.ui.select.table.selected")}</span>
                                      </div>
                                    ) : (
                                      t("msizer.ui.select.table.select")
                                    )}
                                  </span>
                                  <span className="m-auto hidden group-hover/btn:flex group-hover/btn:visible">
                                    {selectedBundle?.id === solution.id ? (
                                      <RiDeleteBinLine className="text-lg" />
                                    ) : (
                                      t("msizer.ui.select.table.select")
                                    )}
                                  </span>
                                </div>
                              </Button>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                </tbody>
              </table>

              {isFetchingBundles && <TableSkeleton />}
            </ScrollContainer>
          ) : (
            <div className="text-center text-gray-500 text-sm my-3 space-y-2">
              <div>
                Please apply all mandatory filters
                <span className="text-red-500"> (marked with an *) </span>
                in order to see bundle results:
              </div>
              <div className="font-semibold space-y-1">
                {["drive", "motor", "gearbox"].map((device) => {
                  // if mandatoryNotFilledFilters[device] length > 0 then show the device
                  // else don't show it
                  if (mandatoryNotFilledFilters?.[device]?.length > 0) {
                    return (
                      <div key={device}>
                        <span className="font-bold uppercase">{device} </span>
                        <span className=""> ({mandatoryNotFilledFilters?.[device]?.join(", ")})</span>
                      </div>
                    );
                  }
                  return null;
                })}
              </div>
            </div>
          )}
          {/* </DoubleScrollbar> */}
        </div>

        <Pagination
          paging={paging}
          setPaging={setPaging}
          countOfResults={countOfBundles}
          showPagination={!(isFetchingBundles || !mandatoryFiltersFilled)}
        />
      </div>
    </div>
  );
};

export default CorrespondingCrossComponent;
